
  import axios from 'axios'
  import iView from 'view-design'
  import {getCookie} from '@/utils/cookieUtils'
  import {ON_HTTP_ERROR } from '@/vuex/mutation-types'
  import store from '@/vuex/store'
  import router from '@/router/index.js'

  var baseURLStr = window.g.ApiUrl
  // 创建axios实例
  const service = axios.create({
    baseURL:baseURLStr , //服务器地址
    //baseURL:process.env.baseURL,    //本地地址
    timeout: 15000, // 请求超时时间
  })

  axios.defaults.withCredentials = true

  // 添加请求拦截器
  service.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    const wcToken = getCookie('wcToken'); //获取Cookie
    const deviceType = "1" //设备类型（PC端=1）

    config.headers = {
      'Content-Type':'application/json;charset=UTF-8' //设置跨域头部
    };

    if (wcToken) {
     
      //config.params = {'wcToken': wcToken,'deviceType': deviceType}
      config.headers = {'token': wcToken}
      //config.params = {'token': 'eyJhbGciOiJIUzUxMiIsImlhdCI6MTYzNDY5NzQ3MiwiZXhwIjoxNjM0NzgzODcyfQ.eyJ1c2VybmFtZSI6ImFkbWluIiwiLGxvZ2luVGltZSI6IjIwMjEtMTAtMjAgMTA6Mzc6NTIifQ.TXYddwaxleWKhupRtdZBrkKoyqHaMqEYZTP9_7KgNKKTyYgcinAG_rI0E6HICAP3bu7GP5dg5ZSBGEGVcO2Wgw'}
    }
    iView.Spin.show()

    return config;
  },function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  });

  //相应拦截器
  service.interceptors.response.use(
    function(response) {
      if(response.data.code==500){
        let errorStatus = response.data.code
        let errorInfo= response.data.msg
        const httpError= {
          hasError: true,
          status: errorStatus,
          statusText: errorInfo
        }
        store.dispatch(ON_HTTP_ERROR, httpError)
        iView.Spin.hide()
        return Promise.reject(error)
      }else if(response.data.code==700&&response.data.msg=="缺少参数token"){
        this.$Message.error("登录过期，请重新登录");
        this.$router.push("/login");
    
      } else{
        iView.Spin.hide()
      }
      
      //请求正常则返回
      return Promise.resolve(response)
    },
    function(error) {
     /* new  Router({
          routes: [
              {
                path: '/login',
                component: Login
              },
            ]
      }).push("/login") */
      //window.location.href = 'http://localhost:8080';
      // 请求错误则向store commit这个状态变化
      let errorStatus = error.response.status
      let errorInfo
      let errorData = error.response.data
      if (errorStatus === 401){
         router.push({
           path:'/login'
         })
      } else if (errorStatus === 500){
        if (errorData.exception == 'com.netflix.zuul.exception.ZuulException') {
          errorInfo = '网关异常，请联系管理员!'
        } else if (errorData.wcError != null){
          errorInfo = error.response.data.wcError
        } else {
          errorInfo = "服务器发生异常，请联系管理员!"
        }
      }
      const httpError= {
        hasError: true,
        status: errorStatus,
        statusText: errorInfo
      }
      store.dispatch(ON_HTTP_ERROR, httpError)
      iView.Spin.hide()
      return Promise.reject(error)
    }
  )
  export default service





// WEBPACK FOOTER //
// ./src/utils/request.js